import { getRefEducationLevels } from "../../../components/services/httpService";

export async function fetchRefEducationLevels() {
    const res = await getRefEducationLevels();
    if ( !res.ok ) {
        throw new Error( `Failed to fetch reference: education levels: ${ res.status }` );
    }
    return await res.json();
}
